import { G } from '@mobily/ts-belt';
import CategoriesCarousel from '@stitch-fix/mode-react/CategoriesCarousel';
import { SearchCategoryCardsModuleFragment, SearchCategoryCardFragment, CtaFragment, SearchFragment } from '../../utils/hooks/getSearchResults';
interface MoreCategoriesProps {
  moreCategories: SearchFragment['moreCategories'];
}
const formatCta = (cta: CtaFragment | null | undefined) => {
  if (!G.isUndefined(cta) && G.isObject(cta)) {
    return {
      url: cta.destinationPath,
      text: cta.text
    };
  }
  return undefined;
};
const formatEndCard = (endCard: SearchCategoryCardsModuleFragment['endCard']) => {
  if (!G.isUndefined(endCard) && G.isObject(endCard)) {
    return {
      image: endCard.image,
      cta: {
        href: endCard.cta.destinationPath,
        text: endCard.cta.text
      }
    };
  }
  return undefined;
};
const formatCategoryCards = (categoryCards: SearchCategoryCardFragment[]) => {
  return categoryCards.map(({
    destinationPath,
    title,
    image,
    id
  }) => ({
    categoryId: id,
    href: destinationPath,
    image: G.isObject(image) ? image : undefined,
    title: G.isString(title) ? title : undefined
  }));
};
const MoreCategories = ({
  moreCategories
}: MoreCategoriesProps) => {
  if (G.isUndefined(moreCategories) || !G.isObject(moreCategories)) {
    return null;
  }
  const {
    categorySet,
    title,
    cta,
    endCard
  } = moreCategories;
  const moduleCta = formatCta(cta);
  const categoryCards = formatCategoryCards(categorySet.cards);
  const carouselEndCard = formatEndCard(endCard);
  return <CategoriesCarousel ariaLabel={title} categorySetId={categorySet.id} moduleHeader={{
    header: title,
    cta: moduleCta
  }} variant="icon" categoryCards={categoryCards} endCard={carouselEndCard} />;
};
export default MoreCategories;